import { render, staticRenderFns } from "./BuildOrder.vue?vue&type=template&id=03b10d38&scoped=true"
import script from "./BuildOrder.vue?vue&type=script&lang=js"
export * from "./BuildOrder.vue?vue&type=script&lang=js"
import style0 from "./BuildOrder.vue?vue&type=style&index=0&id=03b10d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b10d38",
  null
  
)

export default component.exports